import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../settings/config";
import { getAdminAmbassadorList } from "./UserApis";
import useAxios from "../../utils/useAxios";

export const getMostQuestionMember = createAsyncThunk(
  "member/question",
  async (postData, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/most_question`);
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const getMostAnswerMember = createAsyncThunk(
  "question/member",
  async (postData, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/most_answer`);
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const getMemberDetails = createAsyncThunk(
  "details/member",
  async (id: string | number, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/details/${id}`);
      console.log(data, "member details");

      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const getMemberList = createAsyncThunk(
  "member/list",
  async (paramsData: any, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/search`, {
        params: paramsData,
      });
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const ambassadorApprove = createAsyncThunk(
  "member/list",
  async (paramsData: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(
        `${API_URL}/v1/member/ambassador-approved/`,
        {
          params: paramsData,
        }
      );
      dispatch(getAdminAmbassadorList(paramsData));
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const ambassadorRemove = createAsyncThunk(
  "member/list",
  async (paramsData: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(
        `${API_URL}/v1/member/ambassador-removed/`,
        {
          params: paramsData,
        }
      );
      dispatch(getAdminAmbassadorList(paramsData));
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const ambassadorSuggestion = createAsyncThunk(
  "member/suggestions",
  async (paramsData: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/suggestions/`, {
        params: paramsData,
      });
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const createNeta = createAsyncThunk(
  "neta/create",
  async (data: any, thunkAPI) => {
    const { navigate, formData } = data;

    try {
      let api = useAxios();
      const response = await api.post(`${API_URL}/v1/member/member/`, formData);
      if (navigate) {
        navigate("/admin/user/neta"); // Example redirect URL
      }
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const editNeta = createAsyncThunk(
  "neta/create",
  async (data: any, thunkAPI) => {
    const { navigate, formData, id } = data;

    try {
      let api = useAxios();
      const response = await api.patch(
        `${API_URL}/v1/member/member/${id}/`,
        formData
      );
      if (navigate) {
        navigate("/admin/user/neta"); // Example redirect URL
      }
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const netaUsers = createAsyncThunk(
  "neta/users",
  async (paramsData: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/member/`, {
        params: paramsData,
      });
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const netaUserDetails = createAsyncThunk(
  "neta/details",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/member/${id}/`);
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const netaVideoListAction = createAsyncThunk(
  "neta/videos",
  async (paramsData: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`${API_URL}/v1/member/neta-videos/`, {
        params: paramsData,
      });
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const createNetaVideos = createAsyncThunk(
  "neta/create/videos",
  async (data: any, thunkAPI) => {
    const { navigate, formData } = data;

    try {
      let api = useAxios();
      const response = await api.post(
        `${API_URL}/v1/member/neta-videos/`,
        formData
      );
      if (navigate) {
        navigate("/admin/user/neta/videos"); // Example redirect URL
      }
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const netaVideosDetails = createAsyncThunk(
  "neta/videos/details",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(
        `${API_URL}/v1/member/neta-videos/${id}/`
      );
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

export const editNetaVideos = createAsyncThunk(
  "neta/create",
  async (data: any, thunkAPI) => {
    const { navigate, formData, id } = data;

    try {
      let api = useAxios();
      const response = await api.patch(
        `${API_URL}/v1/member/neta-videos/${id}/`,
        formData
      );
      if (navigate) {
        navigate("/admin/user/neta/videos"); // Example redirect URL
      }
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const deleteNetaVideos = createAsyncThunk(
  "neta/create",
  async (data: any, thunkAPI) => {
    const { id, page, page_size, district, divisione, upazila } = data;

    try {
      let api = useAxios();
      const response = await api.delete(
        `${API_URL}/v1/member/neta-videos/${id}/`
      );
      thunkAPI.dispatch(
        netaVideoListAction({ page, page_size, district, divisione, upazila })
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const deleteNeta = createAsyncThunk(
  "neta/delete",
  async (data: any, thunkAPI) => {
    const { id, page, page_size, district, divisione, upazila } = data;

    try {
      let api = useAxios();
      const response = await api.delete(
        `${API_URL}/v1/member/member/${id}/`
      );
      thunkAPI.dispatch(
        netaUsers({ page, page_size, district, divisione, upazila })
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const copyNeta = createAsyncThunk(
  "neta/copy",
  async (data: any, thunkAPI) => {
    const { id, page, page_size, district, divisione, upazila } = data;

    try {
      let api = useAxios();
      const response = await api.post(
        `${API_URL}/v1/member/members/${id}/copy/`
      );
      thunkAPI.dispatch(
        netaUsers({ page, page_size, district, divisione, upazila })
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
